import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {LookAndFeelService} from "../../services/lookAndFeelService";
import {DICTIONARY} from "../../dictionary";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import DOMPurify from 'dompurify';


@Component({
	selector: 'email-viewer',
	template: '<iframe #emailFrameEl [srcdoc]="modifiedContent" (load)="onIframeLoad($event)" style="border: none; width: 100%;" class="f-1-0"></iframe>',
})
export class EmailViewerComponent implements OnChanges{

	@Input() content;
	@Input() prioritizeClasses;
	@ViewChild('emailFrameEl') emailFrameEl: ElementRef<HTMLIFrameElement>;
	@Output() onLoad = new EventEmitter<any>;

	constructor(private lfs:LookAndFeelService,
				private sanitizer: DomSanitizer) {
	}

	dic = DICTIONARY;
	modifiedContent: SafeHtml = '';

	scrollBarCss = `::-webkit-scrollbar {
                      width: 10px;
                      height: 10px;
                    }
                    ::-webkit-scrollbar-button {
                        width: 0px;
                        height: 0px;
                    }
                    ::-webkit-scrollbar-thumb {
                        background: ${this.lfs.color};
                        border: 1px solid rgba(0, 0, 0, 0.5);
                        border-radius: 50px;
                    }
                    ::-webkit-scrollbar-thumb:hover {
                        background: ${this.lfs.hoverColor};
                    }
                    ::-webkit-scrollbar-thumb:active {
                        background: ${this.lfs.color};
                    }
                    ::-webkit-scrollbar-track {
                        background: #ffffff;
                        border: 1px solid rgba(0,0,0,0.15);
                        border-radius: 50px;
                    }
                    ::-webkit-scrollbar-track:hover {
                        background: #ffffff;
                    }
                    ::-webkit-scrollbar-track:active {
                        background: #ffffff;
                    }
                    ::-webkit-scrollbar-corner {
                        background: transparent;
                    }`;

	ngOnChanges(changes: SimpleChanges) {
		if (changes.content) {
			const rawHtml = this.content?.html || this.content || '';
			const styleTag = `<style>${this.scrollBarCss}</style>`;

			const fullHtml = rawHtml.includes('<html')
				? rawHtml.replace('</head>', `${styleTag}</head>`)
				: `<html><head>${styleTag}</head><body>${rawHtml}</body></html>`;

			let cleanHtml = DOMPurify.sanitize(fullHtml, { WHOLE_DOCUMENT: true });
			cleanHtml = this.addTargetToTrustifiLinks(cleanHtml);
			this.modifiedContent = this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
		}
	}

	addTargetToTrustifiLinks = (html) => {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		doc.querySelectorAll('a[href]').forEach(link => {
			try {
				const url = new URL(link.getAttribute('href'));
				if (url.hostname === 'trustifi.com' || url.hostname.endsWith('.trustifi.com')) {
					link.setAttribute('target', '_blank');
					link.setAttribute('rel', 'noopener noreferrer');
				}
			} catch (err) {
			}
		});
		return doc.documentElement.outerHTML;
	};

	onIframeLoad(event) {
		const iframe = event.target as HTMLIFrameElement;

		try {
			const doc = iframe.contentDocument || iframe.contentWindow?.document;
			this.onLoad.emit({iframeDoc: doc});
		} catch (e) {
			// Could not access iframe content (cross origin or something else)
		}
	}
}
